import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || "AIzaSyBsW3YLVkKsQXnSe9K-YqUuhsOB7idMfd8",
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || "devlog-7b318.firebaseapp.com",
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || "devlog-7b318",
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || "devlog-7b318.appspot.com",
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || "82317936551",
  appId: process.env.REACT_APP_FIREBASE_APP_ID || "1:82317936551:web:fd428dd57c8effd57e1882"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);

export { auth, db };
export default app;
